import React, { useState } from 'react';
import './Blog.css';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const blogPosts = [
    {
      id: 1,
      title: "The Future of Remote Work: Trends and Opportunities",
      excerpt: "Explore how remote work is reshaping the job market and creating new opportunities for both employers and job seekers.",
      category: "Industry Insights",
      author: "Sarah Johnson",
      date: "March 15, 2024",
      readTime: "5 min read",
      image: "https://f.hubspotusercontent00.net/hubfs/53/blog-post-types.jpg",
      featured: true
    },
    {
      id: 2,
      title: "Top 10 Skills Employers Look for in 2024",
      excerpt: "Discover the most in-demand skills that can boost your career prospects in today's competitive job market.",
      category: "Career Tips",
      author: "Michael Chen",
      date: "March 12, 2024",
      readTime: "7 min read",
 image: "https://f.hubspotusercontent00.net/hubfs/53/blog-post-types.jpg",
      featured: false
    },
    {
      id: 3,
      title: "How to Ace Your Virtual Interview",
      excerpt: "Master the art of virtual interviews with these proven tips and techniques that will help you stand out from the competition.",
      category: "Interview Tips",
      author: "Emily Rodriguez",
      date: "March 10, 2024",
      readTime: "6 min read",
      image: "https://st.depositphotos.com/1224365/3359/i/450/depositphotos_33593165-stock-photo-casual-blogger-woman-working-with.jpg",
      featured: false
    },
    {
      id: 4,
      title: "Building a Strong Professional Network",
      excerpt: "Learn effective strategies for networking that can open doors to new career opportunities and professional growth.",
      category: "Career Tips",
      author: "David Thompson",
      date: "March 8, 2024",
      readTime: "8 min read",
      image: "https://st4.depositphotos.com/12982378/41666/i/450/depositphotos_416664688-stock-photo-young-blonde-woman-headphones-studying.jpg",
      featured: false
    },
    {
      id: 5,
      title: "The Rise of AI in Recruitment",
      excerpt: "Understanding how artificial intelligence is transforming the recruitment process and what it means for job seekers.",
      category: "Industry Insights",
      author: "Lisa Wang",
      date: "March 5, 2024",
      readTime: "9 min read",
      image: "https://st4.depositphotos.com/5392356/25311/i/450/depositphotos_253114434-stock-photo-college-woman-studying-library-looking.jpg",
      featured: false
    },
    {
      id: 6,
      title: "Salary Negotiation: A Complete Guide",
      excerpt: "Master the art of salary negotiation with proven strategies that help you secure the compensation you deserve.",
      category: "Career Tips",
      author: "Robert Kim",
      date: "March 3, 2024",
      readTime: "10 min read",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZkFsS_Nro3dQW1tLMwLX15KNqey-HoWIdziuYk-rrjvpKKK9n-U48J2wj8if4Bq2nmLk&usqp=CAU",
      featured: false
    },
    {
      id: 7,
      title: "The Art of Salary Negotiation",
      excerpt: "Learn the secrets of salary negotiation and how to secure the compensation you deserve.",
      category: "Career Tips",
      author: "Robert Kim",
      date: "March 3, 2024",
      readTime: "10 min read",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzPPXl5xucJFGC7YadD9kLf0J_WPXA9Ruj0Kbnzf3tC7uYRz8ex5DDlfqvAfqDAJyERA8&usqp=CAU",
      featured: false
    }
];

  const categories = ['All', 'Industry Insights', 'Career Tips', 'Interview Tips'];

  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = selectedCategory === 'All' || post.category === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const featuredPost = blogPosts.find(post => post.featured);
  const regularPosts = filteredPosts.filter(post => !post.featured);

  return (
    <div className="blog-container">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="hero-content">
          <h1 className="hero-title">Our Blog</h1>
         
        </div>
      </section>

      {/* Search and Filter Section */}
    

      

      {/* Blog Posts Grid */}
      <section className="blog-posts">
        <div className="container">
          <h2 className="section-title">
            {selectedCategory === 'All' ? 'Latest Articles' : `${selectedCategory} Articles`}
          </h2>
          <div className="posts-grid">
            {regularPosts.map(post => (
              <article key={post.id} className="post-card">
                <div className="post-image">
                  <img src={post.image} alt={post.title} />
                </div>
                <div className="post-content">
                  <div className="post-meta">
                    <span className="category">{post.category}</span>
                    <span className="read-time">{post.readTime}</span>
                  </div>
                  <h3 className="post-title">{post.title}</h3>
                  <p className="post-excerpt">{post.excerpt}</p>
                  <div className="post-footer">
                    <div className="author-info">
                      <span className="author">By {post.author}</span>
                      <span className="date">{post.date}</span>
                    </div>
                    <button className="read-more-btn">Read More</button>
                  </div>
                </div>
              </article>
            ))}
          </div>
          
          {filteredPosts.length === 0 && (
            <div className="no-results">
              <h3>No articles found</h3>
              <p>Try adjusting your search terms or category filter.</p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <h2 className="newsletter-title">Stay Updated</h2>
            <p className="newsletter-description">
              Subscribe to our newsletter and never miss the latest insights and career tips.
            </p>
            <div className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email address"
                className="newsletter-input"
              />
              <button className="newsletter-btn">Subscribe</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;